import { Offer } from 'models/offer.model';
import { FormControl } from '@angular/forms';
import { OfferViewDTO } from './offer-view-dto.type';

export type InsuranceItemControls = {
  id: FormControl;
  itemsNature: FormControl;
  quotationRequired: FormControl;
  insuranceRate: FormControl;
  pricingRate: FormControl;
  maxValue: FormControl;
  basePricing: FormControl;
  position: FormControl;
  offer: FormControl;
};

export interface IInsuranceItem {
  id?: number;
  itemsNature?: string;
  quotationRequired?: boolean;
  insuranceRate?: number;
  pricingRate?: number;
  maxValue?: number;
  basePricing?: number;
  position?: number;
  offer?: Offer;
  notifyOneByOneActivated?: boolean;
  monthlyReportActivated?: boolean;
  warningAmount?: number;
}

export class GlobalInsurance {
  public insuranceChoice?: string;
  public itemNature?: string;
  public maxValue?: number;
  public basePricing?: number;
  public insuranceRate?: number;
  public pricingRate?: number;
  public offers?: OfferViewDTO[];
  public notifyOneByOneActivated?: boolean;
  public monthlyReportActivated?: boolean;
  public warningAmount?: number;
}

export class InsuranceItem implements IInsuranceItem {
  constructor(
    public id?: number,
    public itemsNature?: string,
    public quotationRequired?: boolean,
    public insuranceRate?: number,
    public pricingRate?: number,
    public maxValue?: number,
    public basePricing?: number,
    public position?: number,
    public offer?: Offer
  ) {
    this.quotationRequired = this.quotationRequired ?? false;
  }
}

export function getInsuranceItemIdentifier(insuranceItem: IInsuranceItem): number | undefined {
  return insuranceItem.id;
}
